import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export const HeroSection = () => {
  return <section className="pt-8 pb-4 sm:pt-12" data-id="element-340">
      <FadeIn data-id="element-341">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white text-center leading-tight mb-6" data-id="element-342">
          ¿Sigues Despertando a las 2 AM con el{' '}
          <span className="text-amber-500" data-id="element-343">Pecho en Llamas?</span>
        </h1>
        <p className="text-lg sm:text-xl text-slate-300 text-center leading-relaxed mb-8 font-medium" data-id="element-344">
          El Mapa de la Noche Sin Reflujo: El Protocolo 3-2-1 que Apaga el Fuego
          en tu Garganta y te Devuelve el Sueño Profundo en 7 Noches o te
          Devolvemos tu Dinero.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-345">
        <div className="rounded-2xl overflow-hidden border border-slate-800 shadow-2xl mb-8" data-id="element-346">
          <img src="https://cdn.magicpatterns.com/uploads/5mwDNdvftdCns9V5rRfezf/noche_reflujo_gpt.png" alt="Hombre sufriendo de reflujo en la cama a las 2 AM" className="w-full h-auto object-cover" data-id="element-347" />
        </div>
        <p className="text-xl text-amber-400 font-medium italic text-center px-4" data-id="element-348">
          "Llevaba 4 años despertándome cada noche con ardor en la garganta."
        </p>
      </FadeIn>
    </section>;
};